export const ICON_NAMES = [
  "app-window",
  "award",
  "barChart",
  "battery-low",
  "brain",
  "brain-circuit",
  "briefcase",
  "calendar",
  "clipboard-list",
  "clock",
  "clock-3",
  "compass",
  "dcm",
  "eye-off",
  "facebook",
  "focus",
  "gauge",
  "globe",
  "grip-vertical",
  "heart",
  "heart-crack",
  "home",
  "instagram",
  "layers",
  "lightbulb",
  "linkedin",
  "location",
  "lock",
  "message",
  "mic",
  "palette",
  "panel-left",
  "rocket",
  "search",
  "settings",
  "shield",
  "shield-check",
  "sparkles",
  "square",
  "star",
  "target",
  "trending-up",
  "trophy",
  "users",
  "youtube",
] as const;

export type TIconName = (typeof ICON_NAMES)[number];
